import { DocumentUploadService } from '@xengage/gw-portals-document-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class PolicyService {
    static getAccountPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'getAccountPolicySummaries',
            [],
            authHeader
        );
    }

    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers​
    static getAccountPolicyOffers(authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'getAccountPolicyOffers',
            [],
            authHeader
        );
    }

     // 2024-12-02 - Debra Frum - US25427 - CE - Make a Payment on Offer Details
     static getAccountOfferDetails(offerNumber, authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'getAccountOfferDetails',
            [offerNumber],
            authHeader
        );
    }
     
    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'getAccountPolicyDetails',
            [policyNumber],
            authHeader
        );
    }

    static updatePrivacyPolicy(policyNumber, decision, authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'updatePolicyPrivacyOptOut',
            [policyNumber, decision],
            authHeader
        );
    }

    static removeDocument(publicID, authHeader = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('removePolicyDocument'),
            'removeDocument',
            [publicID],
            authHeader
        );
    }

    static uploadDocument(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(
            getProxiedServiceUrl('uploadPolicyDocument'),
            document,
            documentMetadata,
            authHeader
        );
    }

    static getDocumentUploadToken(params, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('generateUploadToken'),
            'generateUploadToken',
            params,
            additionalHeaders
        );
    }

    static retrievePolicyFromPolicyCenter(id, lossDate, sessionID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policyclaim'),
            'retrievePolicyPeriod',
            [id, lossDate, sessionID],
            additionalHeaders
        )
    }

    static customerPayAndBind_TWIA(offerNumber, bindData, overrideDupPayment, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'customerPayAndBind_TWIA',
            [offerNumber, bindData, overrideDupPayment],
            additionalHeaders
        )
    }

    static getAccountPolicySummaries_TWIA(searchType, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'getAccountPolicySummaries_TWIA',
            [searchType],
            additionalHeaders
        )
    }

    

}
